var App = App || {};

App.Faq = (() => {
    'use strict';

    const init = (id) => {
        const widget = document.getElementById(id);
        const accordions = widget?.querySelectorAll('.accordion');
        if (accordions?.length) {
            accordions.forEach(accordion => {
                const viewMore = widget?.querySelector(`button[aria-controls="${accordion.id}"]`);

                if (viewMore) {
                    viewMore.addEventListener('click', () => {
                        const isExpanded = viewMore.getAttribute('aria-expanded') === 'true';

                        if (!isExpanded) {
                            viewMore.setAttribute('aria-expanded', 'true');
                            viewMore.textContent = 'View Less -';
                            accordion.querySelectorAll('.accordion-item.d-none').forEach(item => {
                                item.classList.add('accordion-item-conditional');
                                item.classList.remove('d-none');
                            });
                        } else {
                            viewMore.setAttribute('aria-expanded', 'false');
                            viewMore.textContent = 'View More +';
                            accordion.querySelectorAll('.accordion-item.accordion-item-conditional').forEach(item => {
                                item.classList.remove('accordion-item-conditional');
                                item.classList.add('d-none');
                            });
                        }
                    });
                }
            });
        }
    }

    return {
        init
    };
})();